
import { handleError } from '@/plugins/helper'
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RelatedArticles from '~/sections/vision/ai-workspace/related-articles.vue'
import AiWorkspaceKv from '~/sections/vision/child-kv.vue'
import AiWorkspaceProgram from '~/sections/vision/child-program.vue'
import Initiatives from '~/sections/vision/initiatives.vue'

export default {
  components: {
    TextPressure,
    PageBottom,
    FooterNew,
    AuroraBackground,
    Initiatives,
    AiWorkspaceKv,
    RelatedArticles,
    AiWorkspaceProgram
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }) {
    const articles = await $content('article/all')
      .limit(4)
      .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
      .fetch()
      .catch(handleError)

    return { articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    return {
      articles: [],
      initiatives: [
        {
          icon: '/images/vision/icon-chatbox.svg',
          title: 'SAI',
          description:
            '自社で開発した全社員用の生成AIプラットフォームです。安全性を確保しつつ、チャットや独自アプリ作成により、専門知識不要で誰でも業務効率化や生産性向上を図れるWebツールです。',
          link: {
            text: '活用事例',
            url: 'https://techcon2025.dena.dev/sessions/aic-1530/'
          }
        },
        {
          icon: '/images/vision/icon-search.svg',
          title: 'ChatAI',
          description:
            'RAGを活用し、社内ドキュメントを基にAIが回答するSlack Appです。社内情報を参照した回答を生成可能で、新問合せツール「Findout」のAI回答機能のベースになっています。',
          link: {
            text: '活用事例',
            url: 'https://engineering.dena.com/blog/2025/09/replace-findout-eng/'
          }
        },
        {
          icon: '/images/vision/icon-network.svg',
          title: 'ツール利用申請',
          description:
            'AIがツールの利用規約を自動でチェックし、リスク判定や要約を作成します。人間による目視確認の一部を代替することで、申請から利用開始までの待ち時間を大幅に短縮しています。',
          link: {
            text: '活用事例',
            url: 'https://engineering.dena.com/blog/2026/01/legal-check-automation/'
          }
        },
        {
          icon: '/images/vision/icon-ai.svg',
          title: 'AIエージェント\n利用基盤整備',
          description:
            'セキュリティを保ちつつ外部のツールやデータ（データベース、ファイル、Web APIなど）と連携してAIを活用するための管理体制を構築しています。'
        },
        {
          icon: '/images/vision/icon-house.svg',
          title: 'データマネジメント',
          description:
            'データと生成AIを統合し、分析から事業立案まで支援する基盤を開発中です 。2026年度には市場調査や収支試算等の検討プロセスもAI化し、データに基づいた迅速な事業創出を目指しています 。'
        },
        {
          icon: '/images/vision/icon-store.svg',
          title: 'AIエージェント\nオーケストレーション',
          description:
            '様々なワークフローツールを保ちいて、複数の専門AIエージェントを「指揮者」役のAI（オーケストレーター）が統括・連携させ、単体では難しい複雑なタスクや大規模な業務プロセス全体を自律的に解決する仕組みを構築していきます。'
        },
        {
          icon: '/images/vision/icon-chat-unknow.svg',
          title: 'Findout\n(社内ヘルプデスク)',
          description:
            'RAGの精度向上を追求した、社内問い合わせ用のプロダクトです。独自の改善サイクルにより回答精度を高めつつ、既存の問い合わせフロー内にAIを統合。ユーザーが特別な操作をすることなく、自然な流れで疑問を自己解決できる仕組みを実現しています。',
          link: {
            text: '活用事例',
            url: 'https://engineering.dena.com/blog/tags/helpdesk/'
          }
        },
        {
          icon: '/images/vision/icon-paper.svg',
          title: 'Ledge\n(ドキュメント更新提案)',
          description:
            'Findoutでの対応内容を基に、社内ドキュメントの不足を補う自動提案機能です。AIが回答できなかったケースや人間が対応した内容を分析し、関連するドキュメントへ追記案を自動生成します。最終的な人間による確認・マージのみでナレッジが拡充されるため、AIの回答精度を維持・向上させる運用負荷を大幅に軽減しています。'
        }
      ]
    }
  },
  head() {
    const title = 'AI Workspace | VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
